import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import api from "@/lib/api";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const { t } = useI18n();

  useEffect(() => {
    const token = params.get("token");
    const error = params.get("error");
    if (error) {
      navigate(`/login?error=${encodeURIComponent(error)}`);
      return;
    }
    if (token) {
      localStorage.setItem("savebox_token", token);
      refresh().then(async () => {
        // If the user has no drive accounts yet, send them to the Accounts page to connect drives.
        try {
          const { data } = await api.get("/drive/accounts");
          if (!Array.isArray(data) || data.length === 0) {
            navigate("/accounts?welcome=1", { replace: true });
            return;
          }
        } catch {
          // ignore – fall back to dashboard
        }
        navigate("/dashboard", { replace: true });
      });
    } else {
      navigate("/login");
    }
  }, [params, navigate, refresh]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="font-mono text-sm text-muted-foreground">{t("auth.signingIn")}</div>
    </div>
  );
}
